//#region ../base/auth/error.ts
const ERROR_CODES = [
	"MISSING_TOKEN",
	"MFA_REQUIRED",
	"RESPONSE_EMPTY"
];
var JwAuthError = class extends Error {
	static CODES = ERROR_CODES;
	name = "JwAuthError";
	code;
	constructor(code) {
		super(code);
		this.code = code;
	}
	toString() {
		return this.code;
	}
};
function isJwAuthError(e) {
	return e instanceof JwAuthError;
}

//#endregion
export { JwAuthError, isJwAuthError };